import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CarnetDeTemps} from '../../../model/Fields';
import {TicketsService} from '../../../services/tickets.service';
import {Observable} from 'rxjs';
import {RolesService} from '../../../services/roles.service';
import {CommonModule} from "@angular/common";
import {HoursPipe} from "../../common/HoursPipe";
import {CancelButtonComponent} from "../../common/cancel-button/cancel-button.component";
import {RouterLink} from "@angular/router";
import {DashBlockCommercialComponent} from "../dash-block/dash-block-commercial/dash-block-commercial.component";

@Component({
    selector: 'app-cdt-infos',
    templateUrl: './cdt-infos.component.html',
    imports: [
        CommonModule,
        HoursPipe,
        CancelButtonComponent,
        RouterLink,
        DashBlockCommercialComponent
    ],
    styleUrls: ['./cdt-infos.component.css']
})
export class CdtInfosComponent implements OnInit {

  @ViewChild('cdtinfomodal') cdtinfomodal: TemplateRef<any>;

  @Input() set show(show: boolean) {
    if (show) {
      this.openModal();
    }
  }

  @Output() showChange = new EventEmitter<boolean>();

  cdt$: Observable<CarnetDeTemps>;

  constructor(private modalService: NgbModal, private ticketsService: TicketsService, public rolesService: RolesService) {
  }

  ngOnInit(): void {
    this.cdt$ = this.ticketsService.getCarnetDeTemps();
  }

  openModal(): void {
    this.modalService.open(this.cdtinfomodal, {size: 'md'}).result.finally(() => {
      this.showChange.emit(false);
    });
  }

}
